import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class VendorClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Tab State
      // -----------------------------------
      active_tab: "open", // 'open' หรือ 'resolved'

      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_status: "",
      filter_claim_type: "",
      filter_supplier: "",

      count: 12,
      page: 1,

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,

      // Form States (for Modal "สร้างการเคลมผู้จำหน่าย")
      form_claim_no: "CLM-2025-0013",
      form_claim_date: "11/01/2025",
      form_supplier: "Thai Motors Ltd.",
      form_ref_grn: "GRN-2025-0154",
      form_ref_po: "PO-2025-0087",
      form_claim_type: t("claim_type_damaged"),
      form_problem_detail: "Received items were damaged during shipping. Packaging was visibly dented and products inside were non-functional.",
      form_expected_solution: t("replacement_product"),
      form_priority: t("priority_high"),
      
      // Items in Modal
      form_claim_items: [
        { id: "PRT-001234", desc: "Compressor Motor 2HP", received_qty: 2, impact_qty: 1, price: 12500, total: 12500 },
        { id: "PRT-004012", desc: "Hydraulic Oil 46 (20L)", received_qty: 5, impact_qty: 2, price: 2400, total: 4800 }
      ],

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary_open: {
        total: 12,
        waiting_response: 5,
        waiting_approve: 3,
        total_value: "125,000"
      },
      summary_resolved: {
        total: 45,
        credit_note: 28,
        replacement: 12,
        total_refund: "580,000"
      },

      // -----------------------------------
      // Mock Data: Table List
      // -----------------------------------
      data_open: [
        { id: "CLM-2025-0012", date: "10/01/2025", supplier: "Thai Motors Ltd.", ref_grn: "GRN-2025-0156", type: t("claim_type_quality_issue"), typeColor: "danger", items: 2, amount: "45,000", status: t("claim_status_waiting_response"), statusColor: "warning" },
        { id: "CLM-2025-0011", date: "08/01/2025", supplier: "ABC Parts Co.", ref_grn: "GRN-2025-0152", type: t("claim_type_shortage"), typeColor: "warning", items: 1, amount: "12,500", status: t("claim_status_supplier_responded"), statusColor: "purple" },
        { id: "CLM-2025-0010", date: "05/01/2025", supplier: "XYZ Industrial", ref_grn: "GRN-2025-0148", type: t("claim_type_damaged"), typeColor: "warning", items: 3, amount: "28,000", status: t("claim_status_waiting_response"), statusColor: "warning" },
        { id: "CLM-2025-0009", date: "03/01/2025", supplier: "Thai Motors Ltd.", ref_grn: "GRN-2025-0145", type: t("claim_type_late_delivery"), typeColor: "primary", items: 5, amount: "39,500", status: t("claim_status_draft"), statusColor: "secondary" }
      ],
      data_resolved: [
        { id: "CLM-2025-0008", supplier: "ABC Parts Co.", type: t("claim_type_quality_issue"), typeColor: "danger", amount: "25,000", resolve_type: t("credit_note"), resolveColor: "primary", resolve_amount: "25,000", resolve_date: "02/01/2025" },
        { id: "CLM-2025-0007", supplier: "XYZ Industrial", type: t("claim_type_damaged"), typeColor: "warning", amount: "18,500", resolve_type: t("replacement_product"), resolveColor: "purple", resolve_amount: "18,500", resolve_date: "28/12/2024" },
        { id: "CLM-2025-0006", supplier: "Thai Motors Ltd.", type: t("claim_type_shortage"), typeColor: "warning", amount: "8,000", resolve_type: t("resolve_type_refund"), resolveColor: "success", resolve_amount: "8,000", resolve_date: "25/12/2024" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  formatNumber = (num) => {
    return num?.toLocaleString('en-US') || "0";
  };
render() {
    const { 
      active_tab, summary_open, summary_resolved, data_open, data_resolved,
      filter_search, filter_status, filter_claim_type, filter_supplier,
      modal_create, form_claim_no, form_claim_date, form_supplier, form_ref_grn, form_ref_po, 
      form_claim_type, form_claim_items, form_problem_detail, form_expected_solution, form_priority
    } = this.state;

    const currentSummary = active_tab === 'open' ? summary_open : summary_resolved;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
            <div className="mb-4">
              <h3 className="fw-bold mb-1 text-dark">{t("supplier_claims")}</h3>
              <div className="text-secondary text-14">{t("manage_supplier_claims")}</div>
            </div>

          {/* Tabs Control */}
          <div className="d-flex border-bottom border-light mb-4 text-14">
            <div 
              className={`py-2 px-4 pointer d-flex align-items-center fw-bold transition-hover ${active_tab === 'open' ? 'text-primary' : 'text-secondary'}`}
               style={{borderBottom: active_tab === 'open' ? "3px #1976D2 solid": ""}}
               onClick={() => this.setState({ active_tab: 'open' })}
            >
              <span className="icon me-2">{"\uf07b"}</span> {t("open_claims_tab")}
            </div>
            <div 
              className={`py-2 px-4 pointer d-flex align-items-center fw-bold transition-hover ${active_tab === 'resolved' ? 'text-primary' : 'text-secondary'}`}
               style={{borderBottom: active_tab === 'resolved' ? "3px #1976D2 solid": ""}}
               onClick={() => this.setState({ active_tab: 'resolved' })}
            >
              <span className="icon me-2">{"\uf058"}</span> {t("resolved_claims_tab")}
            </div>
          </div>

          {/* Top Stats Cards */}
          <div className="row g-3 mb-4">
            {active_tab === 'open' ? (
              <>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf15b"}</div>
                      <div><h3 className="fw-bold text-dark mb-0">{currentSummary.total}</h3><div className="text-secondary text-12 fw-bold">{t("total_claims")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf017"}</div>
                      <div><h3 className="fw-bold text-warning mb-0">{currentSummary.waiting_response}</h3><div className="text-secondary text-12 fw-bold">{t("waiting_response")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf252"}</div>
                      <div><h3 className="fw-bold text-dark mb-0">{currentSummary.waiting_approve}</h3><div className="text-secondary text-12 fw-bold">{t("waiting_approve")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{"\uf15c"}</div>
                      <div><h3 className="fw-bold text-danger mb-0">{currentSummary.total_value}</h3><div className="text-secondary text-12 fw-bold">{t("total_claim_value")}</div></div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                      <div><h3 className="fw-bold text-dark mb-0">{currentSummary.total}</h3><div className="text-secondary text-12 fw-bold">{t("resolved_this_year")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf09d"}</div>
                      <div><h3 className="fw-bold text-dark mb-0">{currentSummary.credit_note}</h3><div className="text-secondary text-12 fw-bold">{t("credit_note")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf466"}</div>
                      <div><h3 className="fw-bold text-dark mb-0">{currentSummary.replacement}</h3><div className="text-secondary text-12 fw-bold">{t("replacement_product")}</div></div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf1da"}</div>
                      <div><h3 className="fw-bold text-success mb-0">{currentSummary.total_refund}</h3><div className="text-secondary text-12 fw-bold">{t("total_refund")}</div></div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Main Container */}
          <div className="bg-white rounded-4 shadow-sm p-4">
            
            {/* Filter Toolbar */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
              <div className="d-flex gap-3 flex-wrap flex-grow-1">
                <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                  <input type="text" className="form-control ps-5 rounded-3 border-light bg-light" placeholder={t("search_claim_no")} />
                </div>
                <Select
                    className="form-control wpx-150 fw-bold text-secondary"
                    options={[{ value: "", label: t("all_statuses") }]}
                    value=""
                    onChange={() => {}}
                    placeholder={t("all_statuses")}
                    default={false}
                />
                <Select
                    className="form-control wpx-150 fw-bold text-secondary"
                    options={[{ value: "", label: t("all_claim_types") }]}
                    value=""
                    onChange={() => {}}
                    placeholder={t("all_claim_types")}
                    default={false}
                />
                <Select
                    className="form-control wpx-180 fw-bold text-secondary"
                    options={[{ value: "", label: t("supplier") }]}
                    value=""
                    onChange={() => {}}
                    placeholder={t("supplier")}
                    default={false}
                />
              </div>
              <div className="d-flex gap-2">
                {active_tab === 'resolved' && (
                  <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center">
                    <span className="icon me-2">{"\uf019"}</span> {t("export")}
                  </button>
                )}
                <button 
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" 
                  style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                  onClick={() => this.setState({ modal_create: true })}
                >
                  <span className="me-2 text-16">+</span> {t("create_claim")}
                </button>
              </div>
            </div>

            {/* Table Area */}
            <div className="table-responsive">
              {active_tab === 'open' ? (
                <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                  <thead>
                    <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                      <th className="py-3 px-2 border-0 wpx-150">{t("claim_no")}</th>
                      <th className="py-3 border-0 text-center wpx-120">{t("claim_date")}</th>
                      <th className="py-3 border-0 wpx-200">{t("supplier")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("ref_grn")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("claim_type")}</th>
                      <th className="py-3 border-0 text-center wpx-100">{t("items")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("claim_amount")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("status")}</th>
                      <th className="py-3 border-0 text-center wpx-120">{t("manage")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data_open.map((item, idx) => (
                      <tr key={idx} className={`border-bottom border-light ${item.status === 'รอการตอบกลับ' || item.status === 'Waiting for Response' ? 'bg-warning-light' : 'bg-white'}`}>
                        <td className="py-3 px-2 font-monospace fw-bold text-primary pointer hover-underline">{item.id}</td>
                        <td className="text-center text-secondary text-14">{item.date}</td>
                        <td className="text-dark text-14">{item.supplier}</td>
                        <td className="text-center text-secondary text-14">{item.ref_grn}</td>
                        <td className="text-center">
                          <span className={`badge bg-${item.typeColor}-light text-${item.typeColor} rounded-pill px-2 py-1 text-10 border`}>{item.type}</span>
                        </td>
                        <td className="text-center fw-bold text-dark text-14">{item.items}</td>
                        <td className="text-center fw-bold text-danger text-14">{item.amount}</td>
                        <td className="text-center">
                          <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10`}>{item.status}</span>
                        </td>
                        <td className="text-center">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            {item.id === "CLM-2025-0009" ? (
                              <>
                                <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" />
                                <ActionIconButton label={t("submit_claim")} icon={"\uf1d8"} variant="primary" />
                                <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" />
                              </>
                            ) : (
                              <>
                                <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" />
                                <ActionIconButton label={t("submit_claim")} icon={"\uf1d8"} variant="primary" />
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                  <thead>
                    <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                      <th className="py-3 px-2 border-0 wpx-150">{t("claim_no")}</th>
                      <th className="py-3 border-0 wpx-200">{t("supplier")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("claim_type")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("claim_amount")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("resolve_type")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("resolved_amount")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("resolved_date")}</th>
                      <th className="py-3 border-0 text-center wpx-120">{t("manage")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data_resolved.map((item, idx) => (
                      <tr key={idx} className="border-bottom border-light bg-white">
                        <td className="py-3 px-2 font-monospace fw-bold text-primary pointer hover-underline">{item.id}</td>
                        <td className="text-dark text-14">{item.supplier}</td>
                        <td className="text-center">
                          <span className={`badge bg-${item.typeColor}-light text-${item.typeColor} rounded-pill px-2 py-1 text-10 border`}>{item.type}</span>
                        </td>
                        <td className="text-center fw-bold text-dark text-14">{item.amount}</td>
                        <td className="text-center">
                          <span className={`badge bg-${item.resolveColor}-light text-${item.resolveColor} rounded-pill px-2 py-1 text-10 border`}>{item.resolve_type}</span>
                        </td>
                        <td className="text-center fw-bold text-success text-14">{item.resolve_amount}</td>
                        <td className="text-center text-secondary text-14">{item.resolve_date}</td>
                        <td className="text-center">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" />
                            <ActionIconButton label={t("print")} icon={ACTION_ICONS.print} variant="primary" />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-4 text-secondary text-12">
              <div>{t("showing")} 1-4 {t("from")} 12 {t("records_unit")}</div>
              <Pagination count={3} showFirstButton={false} showLastButton={false} onChange={() => {}} />
            </div>
          </div>
        </div>

        {/* MODAL: สร้างการเคลมผู้จำหน่าย */}
        <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
          <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("create_supplier_claim_title")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white" >
            
            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("claim_no")}</label>
                <input type="text" className="form-control py-2 rounded-3 text-secondary bg-light border-light" value={form_claim_no} readOnly />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("claim_date")} <span className="text-danger">{t("required_field")}</span></label>
                <div className="position-relative">
                  <input type="text" className="form-control py-2" value={form_claim_date} />
                  <span className="icon position-absolute top-50 end-0 translate-middle-y me-3 text-secondary">{"\uf073"}</span>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("supplier")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2"
                  options={form_supplier ? [{ value: form_supplier, label: form_supplier }] : []}
                  value={form_supplier}
                  onChange={() => {}}
                  placeholder={t("supplier")}
                  default={false}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("ref_grn")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2"
                  options={form_ref_grn ? [{ value: form_ref_grn, label: form_ref_grn }] : []}
                  value={form_ref_grn}
                  onChange={() => {}}
                  placeholder={t("ref_grn")}
                  default={false}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("ref_po")}</label>
                <input type="text" className="form-control py-2 rounded-3 text-secondary bg-light border-light" value={form_ref_po} readOnly />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("claim_type")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2"
                  options={form_claim_type ? [{ value: form_claim_type, label: form_claim_type }] : []}
                  value={form_claim_type}
                  onChange={() => {}}
                  placeholder={t("claim_type")}
                  default={false}
                />
              </div>
            </div>

            {/* Items List */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold text-dark mb-0">{t("claim_items_list")}</h6>
                <button className="btn btn-sm text-primary fw-bold d-flex align-items-center px-0"><span className="me-1">+</span> {t("add_item")}</button>
              </div>
              <div className="table-responsive bg-light p-2 rounded-3 border border-light">
                <table className="table align-middle mb-0 border-0 text-12">
                  <thead>
                    <tr className="text-dark fw-bold">
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("part_code")}</th>
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("description")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-80">{t("received_qty")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-120">{t("impact_qty")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("unit_price")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("claim_value")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-40"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {form_claim_items.map((item, idx) => (
                      <tr key={idx} className="bg-transparent border-bottom border-white">
                        <td className="py-2 px-1">
                          <Select
                            className="form-control form-control-sm rounded-2 border-light"
                            options={[{ value: item.id, label: item.id }]}
                            value={item.id}
                            onChange={() => {}}
                            placeholder={t("part_code")}
                            default={false}
                          />
                        </td>
                        <td className="py-2 text-secondary px-1">{item.desc}</td>
                        <td className="py-2 text-center text-dark px-1">{item.received_qty}</td>
                        <td className="py-2 px-1"><input type="number" className="form-control form-control-sm text-center rounded-2 border-light" value={item.impact_qty} /></td>
                        <td className="py-2 text-center text-dark px-1">{this.formatNumber(item.price)}</td>
                        <td className="py-2 text-center text-danger fw-bold px-1">{this.formatNumber(item.total)}</td>
                        <td className="py-2 text-center px-1"><span className="icon text-danger pointer text-14">{"\uf2ed"}</span></td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="5" className="text-end py-3 bg-transparent text-dark fw-bold border-0 text-14">{t("total_claim_value")}</td>
                      <td className="text-center py-3 bg-transparent text-danger fw-bold border-0 text-16">17,300</td>
                      <td className="border-0 bg-transparent"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Detail & Upload */}
            <div className="mb-4">
              <label className="form-label text-14 text-dark fw-bold mb-2">{t("problem_detail")} <span className="text-danger">{t("required_field")}</span></label>
              <textarea className="form-control py-2 rounded-3 border-light mb-4" rows="3" defaultValue={form_problem_detail}></textarea>
              
              <label className="form-label text-14 text-dark fw-bold mb-2">{t("attachments")}</label>
              <div className="border border-dashed rounded-3 p-5 text-center bg-light pointer transition-hover">
                <span className="icon text-secondary text-32 mb-2 d-block">{"\uf0ee"}</span>
                <div className="text-secondary text-14 mb-3">{t("drag_drop_file")}</div>
                <button className="btn btn-white border px-4 py-2 text-primary fw-bold rounded-2">{t("select_file")}</button>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("expected_solution")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2 rounded-3 border-light bg-white"
                  options={form_expected_solution ? [{ value: form_expected_solution, label: form_expected_solution }] : []}
                  value={form_expected_solution}
                  onChange={() => {}}
                  placeholder={t("expected_solution")}
                  default={false}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("priority")}</label>
                <Select
                  className="form-control py-2 rounded-3 border-light bg-white"
                  options={form_priority ? [{ value: form_priority, label: form_priority }] : []}
                  value={form_priority}
                  onChange={() => {}}
                  placeholder={t("priority")}
                  default={false}
                />
              </div>
            </div>

          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_create: false })}>{t("cancel")}</button>
            <button className="btn btn-outline-primary px-4 py-2 rounded-3 fw-bold bg-white" style={{ color: '#2563eb', borderColor: '#2563eb' }}>{t("save_draft")}</button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}>{t("submit_claim")}</button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}